<script>
  export let primary = false;
  export let secondary = false;
  export let disabled = false;
  export let big = false;
  export let red = false;
  let class_name = '';
  export { class_name as class };
</script>

<button class:primary class:secondary class:big class:red class={class_name} on:click {disabled}>
  <slot />
</button>

<style>
  button {
    background-color: #e0e0e0;
    font-weight: 700;
    padding: 8px 13px;
    border: none;
    border-radius: 20px;
    cursor: pointer;
    outline: none;
    font-size: 14px;
  }
  button:disabled {
    opacity: 0.5;
  }
  button:hover:enabled {
    background-color: #ffbf94;
    color: black;
  }
  .primary {
    background-color: #ffbf94;
  }
  .big {
    background-color: #ffbf94;
    font-size: 16px;
    font-weight: 700;
    padding: 10px 16px;
  }
  .big:hover {
    background-color: #ffbf94;
  }
  .red {
    background-color: #ea0051;
    color: white;
  }
  .big.red {
    background-color: #ea0051;
    color: white;
  }
  .big.red:hover {
    background-color: #f22922;
    color: white;
  }

  .secondary {
    background: none;
    color: white;
  }
</style>
